import i18n from '~/locales/i18n';

i18n.addResourceBundle('ar', 'app', {
  age: 'السن',
  gender: 'النوع',
  maritalStatus: 'الحالة الإجتماعية',
  education: 'التعليم',
  industry: 'مجال العمل',
  position: 'وظيفتك',
  purchaseInfo: 'الهدف من الشراء',
});
